/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Timeline_Font_SizeInputs */



/**
* | output |
* | --- |
* | "Font Size (px)" |
*
* @param {Options_Editor_Timeline_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_timeline_font_size = /** @type {((inputs?: Options_Editor_Timeline_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Timeline_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille de police (px)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftgröße (px)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione carattere (px)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер шрифта (пиксели)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de fuente (px)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体大小（像素）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントサイズ（ピクセル）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट आकार (px)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho da fonte (px)")
	return /** @type {LocalizedString} */ ("Font Size (px)")
});